import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import { Col, Container, Row, Button, Form } from "react-bootstrap";
import { centerActions } from "../../../../redux/actions";
import SSFRegulationsCenter from "../../../../assets/SSFRegulationsCenter.pdf";
import {
  translationConstants,
  fieldLengthConstants,
  globalConstants,
} from "../../../../constants";
import InputFieldWrapper from "../../../../shared/components/InputFieldWrapper/InputFieldWrapper";
import FileUploader from "../../../../shared/components/UploadFile/FileUploader";

const InstructorTab = ({ goBack, onSubmit }) => {
  const methods = useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const formState = useSelector((state) => state.centerReducer.formState);
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const [validationErrorMessage, setValidationErrorMessage] = useState("");

  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onFormSubmit = (dataToSend) => {
    const { IsUserConsented, ...removedPolicy } = dataToSend;
    const finalData = {
      ...formState,
      ...removedPolicy,
    };
    dispatch(centerActions.setFormState(finalData));
    const headInstructorInfo = {
      headInstructorInfo: {
        ...removedPolicy.headInstructorInfo,
        certificate:
          removedPolicy.headInstructorInfo.certificate &&
          removedPolicy.headInstructorInfo.certificate[0],
      },
    };
    onSubmit(headInstructorInfo);
  };

  useEffect(() => {
    if (formState) {
      setValue(
        "headInstructorInfo.certificate",
        formState.headInstructorInfo?.certificate
      );
      setValue("headInstructorInfo.name", formState.headInstructorInfo?.name);
      setValue("headInstructorInfo.email", formState.headInstructorInfo?.email);
    }
    // eslint-disable-next-line
  }, []);

  const goBackHandler = () => {
    const { IsUserConsented, ...currentFinalForm } = getValues();
    const currentValues = {
      ...formState,
      ...currentFinalForm,
    };
    dispatch(centerActions.setFormState(currentValues));
    goBack();
  };

  const handleFileUpload = useCallback(
    (file, key) => {
      setValue(key, file, { shouldValidate: true });
    },
    [setValue]
  );

  return (
    <>
      <FormProvider {...methods}>
        <Form noValidate onSubmit={handleSubmit(onFormSubmit)}>
          <Container>
            <Row>
              <InputFieldWrapper
                label={
                  `${t(translationConstants.HEAD_INSTRUCTOR_NAME)}:` +
                  globalConstants.Mandatory_Character
                }
              >
                <Form.Control
                  type="text"
                  maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                  id="headInstructorInfo.name"
                  placeholder={t(
                    translationConstants.ENTER_HEAD_INSTRUCTOR_NAME
                  )}
                  {...register("headInstructorInfo.name", {
                    required: t(
                      translationConstants.HEAD_INSTRUCTOR_NAME_REQUIRED
                    ),
                    pattern: {
                      value:
                        /^[A-Za-z0-9\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/i,
                      message: t(
                        translationConstants.INVALID_HEAD_INSTRUCTOR_NAME
                      ),
                    },
                  })}
                />
                {errors.headInstructorInfo?.name && (
                  <p className="errorText">
                    {errors.headInstructorInfo?.name.message}
                  </p>
                )}
              </InputFieldWrapper>

              <InputFieldWrapper
                label={
                  `${t(translationConstants.HEAD_INSTRUCTOR_EMAIL)}:` +
                  globalConstants.Mandatory_Character
                }
              >
                <Form.Control
                  {...register("headInstructorInfo.email", {
                    required: t(translationConstants.emailRequired),
                    pattern: {
                      value:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/i,
                      message: t(translationConstants.invalidEmail),
                    },
                  })}
                  id="headInstructorInfo.email"
                  type="headInstructorInfo.email"
                  placeholder="Ex: abc@example.com"
                />
                {errors.headInstructorInfo?.email && (
                  <p className="errorText">
                    {errors.headInstructorInfo?.email.message}
                  </p>
                )}
              </InputFieldWrapper>

              <InputFieldWrapper
                controlId={"headInstructorInfo.certificate"}
                label={
                  `${t(
                    translationConstants.UPLOAD_HEAD_INSTRUCTOR_CERTIFICATE
                  )}:` + globalConstants.Mandatory_Character
                }
              >
                <div className="filterUploader">
                  <FileUploader
                    sm
                    single
                    defaultValue={formState?.headInstructorInfo?.certificate}
                    {...register("headInstructorInfo.certificate", {
                      required: t(translationConstants.imageRequired),
                    })}
                    onFileUpload={(file) =>
                      handleFileUpload(file, "headInstructorInfo.certificate")
                    }
                    setValidationErrorMessage={setValidationErrorMessage}
                    isError={
                      errors.headInstructorInfo?.certificate ||
                      validationErrorMessage
                    }
                  />
                  {errors.headInstructorInfo?.certificate &&
                    !validationErrorMessage && (
                      <p className="errorText">
                        {errors.headInstructorInfo.certificate.message}
                      </p>
                    )}
                  {validationErrorMessage && (
                    <p className="errorText">{validationErrorMessage}</p>
                  )}
                </div>
              </InputFieldWrapper>

              <Col md={12} className="">
                <Form.Group
                  className="d-flex align-items-center justify-content-space-between registrationCheckBoxs"
                  controlId="formBasicCheckbox"
                >
                  <Form.Check
                    className="custom-checkbox"
                    type="checkbox"
                    label={<p>{t(translationConstants.agreeToTerms)} </p>}
                    {...register("IsUserConsented", {
                      required: t(translationConstants.IsUserConsented),
                    })}
                  />
                  <span
                    onClick={() => window.open(SSFRegulationsCenter)}
                    className="ssf-regulations-label"
                  >
                    {t(translationConstants.SSFRegulations)}.
                  </span>
                  {errors.IsUserConsented && (
                    <p className="errorText">
                      {errors.IsUserConsented.message}
                    </p>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12} className="d-flex justify-content-center mt-4">
                <div className="d-flex">
                  <Button
                    type="button"
                    variant="outline-primary"
                    onClick={goBackHandler}
                    className="btn-submit-outline mx-2"
                  >
                    {t(translationConstants.GO_BACK)}
                  </Button>
                  <Button type="submit" className="btn-submit mx-2">
                    {t(translationConstants.submit)}
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </Form>
      </FormProvider>
    </>
  );
};

export default InstructorTab;
